"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputAwsConfigIndex = exports.InputBoxConfigIndex = void 0;
/** 金額チェックのパラメータのIndex */
var InputBoxConfigIndex;
(function (InputBoxConfigIndex) {
    InputBoxConfigIndex[InputBoxConfigIndex["FOLDER_ID"] = 0] = "FOLDER_ID";
})(InputBoxConfigIndex = exports.InputBoxConfigIndex || (exports.InputBoxConfigIndex = {}));
var InputAwsConfigIndex;
(function (InputAwsConfigIndex) {
    InputAwsConfigIndex[InputAwsConfigIndex["REGION"] = 0] = "REGION";
    InputAwsConfigIndex[InputAwsConfigIndex["BUCKET"] = 1] = "BUCKET";
    InputAwsConfigIndex[InputAwsConfigIndex["FOLDER"] = 2] = "FOLDER";
    InputAwsConfigIndex[InputAwsConfigIndex["RULE_SET_NAME"] = 3] = "RULE_SET_NAME";
    InputAwsConfigIndex[InputAwsConfigIndex["EMAIL_DOMAIN"] = 4] = "EMAIL_DOMAIN";
})(InputAwsConfigIndex = exports.InputAwsConfigIndex || (exports.InputAwsConfigIndex = {}));
